'use client';

import { c as _c } from "react/compiler-runtime";
import { useEngineerIdentity } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { isMorfiMarketsEmail } from '@/config/operator-dashboard';
export function FundingDevtoolsLink(t0) {
  const $ = _c(5);
  const {
    onOpen
  } = t0;
  const {
    user,
    isAuthenticated
  } = useEngineerIdentity();
  const t = useTranslations("onramp.devtools");
  if (!isAuthenticated || !isMorfiMarketsEmail(user?.email)) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("view");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onOpen || $[3] !== t1) {
    t2 = <AnimatedButton variant="secondary" onClick={onOpen}>{t1}</AnimatedButton>;
    $[2] = onOpen;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}